import styled from 'styled-components/native';

import Item from 'components/ArtistsList/styled/Item';

export default styled(Item)`
  padding-top: 20px;
  width: 100%;
`;
